import type { OpenLoop } from '../open-loops/wire';

export function loopPriority(loop: OpenLoop): string | null {
  return typeof loop === 'object' && loop !== null ? loop.priority ?? null : null;
}

export function loopResponsibility(loop: OpenLoop): string | null {
  return typeof loop === 'object' && loop !== null ? loop.responsibility ?? null : null;
}

/**
 * The loop's source calendar day (`YYYY-MM-DD`), or null for the legacy string arm,
 * a loop with no `source.date`, or a date that does not lead with a calendar day.
 * A timestamp is cut to its day so it compares correctly against `YYYY-MM-DD` bounds.
 */
export function loopSourceDate(loop: OpenLoop): string | null {
  const date = typeof loop === 'object' && loop !== null ? loop.source?.date ?? null : null;
  return date ? /^\d{4}-\d{2}-\d{2}/.exec(date)?.[0] ?? null : null;
}
